import * as React from 'react'
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react'

import { ErrorPage } from './error-page'

type ErrorProps = {
  children: React.ReactNode
}

const ErrorBoundary = (props: ErrorProps) => {
  return (
    <SentryErrorBoundary fallback={<ErrorPage />}>
      {props.children}
    </SentryErrorBoundary>
  )
}

export default ErrorBoundary
